<template>
  <div class="printable-window">
    <div class="header-spacing"></div>
    <article>
      <h5 class="warehouse-name">
        <v-icon size="small">mdi-map-marker-outline</v-icon>
        {{ warehouseName }}
        <v-divider class="mt-2" thickness="3" />
      </h5>

      <h1 class="main-title text-center" v-if="action === 'check-in'">
        {{ t('warehouse.pages.settings.headers.quickCheckIn') }}
      </h1>
      <h1 class="main-title text-center" v-else>
        {{ t('warehouse.pages.settings.headers.quickCheckOut') }}
      </h1>

      <div class="d-flex flex-column justify-center align-center">
        <div class="instructions">
          <div class="qrcode-box">
            <div :id="`qrcode-template-placeholder-${action}`"></div>
          </div>
        </div>

        <div class="instructions my-8">
          <p class="mb-2">
            <strong>{{ t('warehouse.pages.settings.headers.instructions') }}</strong>
          </p>

          <div>
            <ol class="ml-4">
              <li>{{ t('warehouse.pages.settings.messages.openCameraAndScanCode') }}</li>
              <li>{{ t('warehouse.pages.settings.messages.tapLinkThatAppears') }}</li>
              <li>{{ t('warehouse.pages.settings.messages.followOnScreenInstructions') }}</li>
              <li v-if="action === 'check-in'">
                {{ t('warehouse.pages.settings.messages.keepEyeOnTextMessages') }}
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div class="footer">
        <img alt="logo" src="/images/logo_for_print.png" height="32" />
      </div>
    </article>
  </div>
</template>

<script>
import { t } from '@nova/core';

export default {
  name: 'GateManagementTemplate',
  props: {
    warehouseName: {
      type: String,
      required: true
    },
    action: {
      type: String,
      required: false,
      default: 'check-in'
    }
  },
  methods: { t }
};
</script>
<style scoped lang="scss">
@media print {
  @page {
    size: letter;
    margin: 0;
  }
  body {
    margin: 0;
    padding: 0;
    height: 100vh;
    overflow: hidden;
  }
}
.printable-window {
  height: 93vh;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;

  .main-title {
    text-align: center;
    font-size: 48px;
    font-weight: bold;
  }

  .subtitle {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #000000;
  }

  .warehouse-name {
    font-weight: normal !important;
    font-size: 22px;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 40px;
  }

  .instructions {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 30px;
    width: 410px;
  }

  div.qrcode-box {
    border: 12px solid #000000;
    border-radius: 16px 16px;
    width: 400px;
    height: 400px;
  }

  .footer {
    width: 100%;
    text-align: center;
    height: 130px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
